import React from 'react';
import { Container } from 'react-bootstrap';
import styled from 'styled-components';
import { ContactForm } from '../../components';
import { AppSection, AppTitle } from '../Conditions/Conditions';
import ContactBG from '../../assets/images/contact-bg.svg';
// import TerminalForm from '../../components/TerminalForm/TerminalForm';
const Contact = () => {
  return (
    <ContactSection className="contact">

      <StyledContainer>

        <ContactContainer>
          <ContactColumn>
            <AppTitle>Наши контакты</AppTitle>
            <ContactBlock>
              <ContactPhoneBlock>
                <ContactTitle>Телефон</ContactTitle>
                <ContactData href="tel:8 495 120 18 76">
                  8 495 120 18 76
                </ContactData>
                <ContactData href="tel:8 926 999 31 11">
                  8 926 999 31 11
                </ContactData>
              </ContactPhoneBlock>
              <ContactEmailBlock>
                <ContactTitle>Почта</ContactTitle>
                <ContactData href="mailto:fr@energo.app">
                  fr@energo.app
                </ContactData>
              </ContactEmailBlock>
            </ContactBlock>
            <ContactEmailBlock>
              <ContactText>
                ООО “ЭНЕРГО ТЕХНОЛОДЖИС” <br /> 119049, г. Москва, пл.
                Калужская, д.1, к. 1,
                <br /> техническое подполье 2, помещ./каб. I/28
                <br /> ИНН 5024194594
                <br /> ОГРН 1195081019803
                <br />
              </ContactText>
            </ContactEmailBlock>
          </ContactColumn>
          <FormColumn className="contact-form">
            <AppTitle>Заявка на франшизу</AppTitle>
            <ContactForm />
          </FormColumn>
        </ContactContainer>
      </StyledContainer>
      <ContactBgImg></ContactBgImg>

      {/* <TerminalContainer>
        <ContactContainer>
          <ContactColumn>
            <AppTitle>
              ИЛИ
            </AppTitle>
          </ContactColumn>
          <FormColumn className="contact-form">
            <AppTitle>Заявка на установку терминала в вашем заведении</AppTitle>
            <TerminalForm />
          </FormColumn>
        </ContactContainer>
      </TerminalContainer>
      <TerminalBgImg></TerminalBgImg> */}
    </ContactSection>
  );
};

const StyledContainer = styled(Container)`
  @media (max-width: 599px) {
    width: 100%;
    padding: 0;
  }
`;
// const TerminalContainer = styled(Container)`
//   margin-top:80px;
//   @media (max-width: 599px) {
//     width: 100%;
//     padding: 0;
//   }
// `;

const ContactSection = styled(AppSection)`
  padding: 80px 0 160px 0;
  @media (max-width: 1135px) {
    padding: 80px 0 57px 0;
  }
  @media (max-width: 900px) {
    padding: 30px 0 60px 0;
  }
`;

const ContactContainer = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 1135px) {
    flex-direction: column;
  }
  @media (max-width: 599px) {
    margin-bottom: -43px;
  }
`;

const ContactColumn = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 599px) {
    padding-left: 16px;
  }
`;

const ContactBlock = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 1135px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 2.7rem;
    margin-bottom: 4.2rem;
  }
  @media (max-width: 599px) {
    flex-direction: column;
  }
`;

const FormColumn = styled(ContactColumn)`
  width: 45.7%;
  @media (max-width: 1440px) {
    width: 48.7%;
  }
  @media (max-width: 1135px) {
    width: 100%;
    background-color: #ffdc00;
    border-radius: 16px;
    padding: 44px;
    margin-top: 25px;
  }
  @media (max-width: 599px) {
    padding: 47px 15px;
    border-radius: 0;
  }
`;

const ContactBgImg = styled.div`
  position: absolute;
  right: 0;
  top: 2rem;
  width: 57%;
  z-index: -1;
  height: 720px;
  background-image: url(${ContactBG});
  background-size: cover;
  @media (max-width: 1440px) {
    width: 62%;
  }
  @media (max-width: 1135px) {
    display: none;
  }
`;
// const TerminalBgImg = styled.div`
//   transform:scale(1,-1);
//   position: absolute;
//   right: 0;
//   top: 48rem;
//   width: 57%;
//   z-index: -1;
//   height: 870px;
//   background-image: url(${ContactBG});
//   background-size: cover;
//   @media (max-width: 1440px) {
//     width: 62%;
//   }
//   @media (max-width: 1135px) {
//     display: none;
//   }
// `;

const ContactPhoneBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2.7rem;
  @media (max-width: 1135px) {
    margin-top: 0;
  }
`;

const ContactTitle = styled.div`
  font-weight: 400;
  font-size: 20px;
  color: #a2a8b0;
  margin-bottom: 13px;
  @media (max-width: 599px) {
    margin-bottom: 7px;
  }
`;

const ContactData = styled.a`
  font-weight: 600;
  font-size: 40px;
  margin-bottom: 1rem;
  color: #26292d;
  &:hover {
    color: #26292d;
  }
  @media (max-width: 1135px) {
    font-size: 5.4vw;
  }
  @media (max-width: 599px) {
    font-size: 8.4vw;
    margin-bottom: 0.4rem;
  }
`;

const ContactEmailBlock = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1.3rem;
  @media (max-width: 1135px) {
    margin-top: 0;
    width: 48%;
  }
  @media (max-width: 599px) {
    margin-top: 26px;
    width: 73%;
  }
`;

const ContactText = styled.p`
  font-weight: 400;
  font-size: 16px;
  color: #a2a8b0;
  line-height: 25px;
  @media (max-width: 1135px) {
    line-height: 27px;
  }
  @media (max-width: 599px) {
    margin-top: -69px;
  }
`;

export default Contact;
